export class MessagingRule {
  id;
  clientId;
  strategyId;
  dayOfWeek;
  periodStart;
  periodEnd;
  deviceType;
  numberOfLogin = 0;
  useExactDate;
  date;
  enterMessage = '';
  exitMessage = '';
  useWiredmessenger;
  wiredmessengerCampaignName;
  wiredmessengerCustomStoreAddress;
  wiredmessengerCustomStoreCity;
  wiredmessengerCustomStoreName;
  wiredmessengerCustomStoreNumber;
  wiredmessengerListId;
  wiredmessengerTemplateId;
  wiredmessengerUUID;

  constructor(obj?: Location) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/messaging-strategies/messaging-rule.model.ts